import { TextField, TextFieldProps } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";

export default function TextFieldCurrency(
  props: Omit<TextFieldProps, "onChange"> & { onChange: (value: number) => void }
) {
  const [value, setValue] = useState(props.value ?? props.defaultValue);
  const [notANumber, setNotANumber] = useState<boolean>(false);
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const currency = "EUR";
  const currencySymbol = useMemo(() => {
    const formatter = new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: currency,
      currencyDisplay: "symbol",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return formatter.format(0).replace(/\d/g, "");
  }, [currency]);

  return (
    <TextField
      {...props}
      InputProps={{ startAdornment: currencySymbol }}
      aria-errormessage={"Not a number"}
      error={notANumber}
      onChange={(e) => {
        let val = e.target.value;
        if (val.charAt(val.length - 1) === ",") {
          val = val.replace(",", ".");
        }

        setValue(val);
        const n = Number(val);

        setNotANumber(Number.isNaN(n));

        if (!Number.isNaN(n)) {
          props.onChange?.(n);
        }
      }}
      value={value}
    />
  );
}
